import React, { Component } from 'react'
import { connect } from 'react-redux'
import {
  openModal,
  closeModal
} from 'actions/modals'
import { VISIT_ENDED_MODAL } from 'constants/modals'
import VisitEndedModal from 'components/VisitEndedModal'
import { sendFeedback } from 'actions/api/visits'

export class VisitEndedModalContainer extends Component {


  componentDidUpdate(prevProps) {
    if (!prevProps.visitEnded && this.props.visitEnded) {
      this.props.openModal()
    }
  }

  render() {
    const {
      closeModal,
      isInitiator,
      modalOpened,
      rate,
      totalMinutes,
      amountCharged,
      couponMinutes,
      redirectURL,
      sendFeedback
    } = this.props


    return (
      <VisitEndedModal
        show={modalOpened}
        closeModal={closeModal}
        rate={rate}
        totalMinutes={totalMinutes}
        amountCharged={amountCharged}
        couponMinutes={couponMinutes}
        redirectURL={redirectURL}
        sendFeedback={sendFeedback}
      />
    )
  }
}

function mapStateToProps (state) {
  return {
    modalOpened: state.modal.currentModal === VISIT_ENDED_MODAL,
    rate: state.payment.rate,
    visitEnded: state.visit.visitEnded,
    redirectURL: state.visit.redirectURL,
    totalMinutes: state.visit.visitEndedDetails && state.visit.visitEndedDetails.totalMinutes,
    amountCharged: state.visit.visitEndedDetails && state.visit.visitEndedDetails.amountCharged,
    couponMinutes: state.visit.visitEndedDetails && state.visit.visitEndedDetails.couponMinutes
  }
}

function mapDispatchToProps (dispatch) {
  return {
    openModal: () => dispatch(openModal(VISIT_ENDED_MODAL)),
    closeModal: () => dispatch(closeModal(VISIT_ENDED_MODAL)),
    sendFeedback: (rating, feedback) => dispatch(sendFeedback(rating, feedback))
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(VisitEndedModalContainer)
